module.exports = __webpack_public_path__ + "img/tn-timeline-main-20.1c0f349b.jpg";